var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home view"},[_c('button',{on:{"click":function($event){return _vm.showPane('edit')}}},[_vm._v(" edit pane ")]),_c('router-link',{attrs:{"to":"/settings"}},[_vm._v(" settings ")]),_vm._v(" 7311440600396 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }